/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Phonenumber1Inputs */

const he_common_phonenumber1 = /** @type {(inputs: Common_Phonenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מספר טלפון`)
};

const en_common_phonenumber1 = /** @type {(inputs: Common_Phonenumber1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Number`)
};

/**
* | output |
* | --- |
* | "Phone Number" |
*
* @param {Common_Phonenumber1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const common_phonenumber1 = /** @type {((inputs?: Common_Phonenumber1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Phonenumber1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_common_phonenumber1(inputs)
	return en_common_phonenumber1(inputs)
});
export { common_phonenumber1 as "common_phoneNumber" }